import React from 'react';
import { View } from 'react-native';

import { HStack, VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';
import type { SearchResultCardSkeletonProps } from './types';

const SearchResultCardSkeleton: React.FC<SearchResultCardSkeletonProps> = ({
  testID,
}) => {
  return (
    <View style={styles.container} testID={testID}>
      <HStack space={theme.spacing[6]} style={styles.contentWrapper}>
        {/* Avatar skeleton */}
        <View style={styles.avatar}>
          <Skeleton variant="rectangular" width={100} height={100} />
        </View>

        <VStack space={theme.spacing[5]} style={styles.content}>
          {/* Name and alias */}
          <VStack space={theme.spacing[2]}>
            <Skeleton variant="text" width={150} height={18} />
            <Skeleton variant="text" width={100} height={14} />
          </VStack>

          {/* Address (2 lines) */}
          <VStack space={theme.spacing[1]}>
            <Skeleton variant="text" width="50%" height={12} />
          </VStack>

          {/* Footer: Directions button + distance */}
          <HStack centerVertical style={styles.footerContainer}>
            <Skeleton variant="text" width={100} height={14} />
            <Skeleton variant="text" width={40} height={14} />
          </HStack>
        </VStack>
      </HStack>
    </View>
  );
};

SearchResultCardSkeleton.displayName = 'SearchResultCardSkeleton';
export { SearchResultCardSkeleton };
